import React, { useEffect, useState } from "react";
import { Box, Table, AspectRatio, Sheet } from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, MapContainer, PageTitle } from "../../../components";
import { FILE_BASE, STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import {
  viewPartnerReset,
  getLoggedInPartnerDetailsRequest,
  getLoggedInPartnerDetailsReset,
} from "../../../store/actions";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const InfoPage = ({
  loginResult,

  getLoggedInPartnerDetailsStatus,
  getLoggedInPartnerDetailsResult,
  getLoggedInPartnerDetailsErrorMessage,
}) => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [partner_type, setPartnerType] = useState("");
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [nearest, setNearest] = useState("");
  const [ward, setWard] = useState("");
  const [street, setStreet] = useState("");
  const [other, setOther] = useState("");
  const [post_code, setPostCode] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [status, setStatus] = useState(0);
  const [remark, setRemark] = useState("");
  // const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState("");

  const [region, setRegion] = useState("");
  const [district, setDistrict] = useState("");

  const [attachments, setAttachments] = useState([
    {
      attachment_name: "",
      attachment_value: "",
      file: null,
      url: "",
    },
  ]);

  useEffect(() => {
    if (getLoggedInPartnerDetailsStatus === STATUS.SUCCESS) {
      setName(getLoggedInPartnerDetailsResult.partnerData.name);
      setEmail(getLoggedInPartnerDetailsResult.partnerData.email);
      setDistrict(getLoggedInPartnerDetailsResult.partnerData.address.district);
      setLocation({
        latitude: getLoggedInPartnerDetailsResult.partnerData.address.latitude,
        longitude:
          getLoggedInPartnerDetailsResult.partnerData.address.longitude,
      });
      setWard(getLoggedInPartnerDetailsResult.partnerData.address.ward);
      setStreet(getLoggedInPartnerDetailsResult.partnerData.address.street);
      setRegion(getLoggedInPartnerDetailsResult.partnerData.address.region);
      setPostCode(
        getLoggedInPartnerDetailsResult.partnerData.address.post_code,
      );
      setNearest(
        getLoggedInPartnerDetailsResult.partnerData.address.nearest_landmark,
      );
      setStatus(getLoggedInPartnerDetailsResult.partnerData.status);
      setOther(
        getLoggedInPartnerDetailsResult.partnerData.address.other_details,
      );
      setZipCode(getLoggedInPartnerDetailsResult.partnerData.address.zip_code);
      setPartnerType(
        getLoggedInPartnerDetailsResult.partnerData.partner_type.toString(),
      );
      setRemark(getLoggedInPartnerDetailsResult.partnerData.remark);
      setAttachments(
        getLoggedInPartnerDetailsResult.attachments.map((item, index) => ({
          attachment_name: item.attachment_name,
          attachment_value: item.attachment_value,
          file: null,
          url: FILE_BASE + "/auth/attachments/" + item.file_path,
        })),
      );
      setTimeout(() => {
        dispatch(viewPartnerReset());
      }, 2000);
    } else if (getLoggedInPartnerDetailsStatus === STATUS.ERROR) {
      toast.error(getLoggedInPartnerDetailsErrorMessage);
      dispatch(getLoggedInPartnerDetailsReset());
    }
  }, [
    dispatch,
    getLoggedInPartnerDetailsErrorMessage,
    getLoggedInPartnerDetailsResult,
    getLoggedInPartnerDetailsStatus,
  ]);

  useEffect(() => {
    dispatch(getLoggedInPartnerDetailsRequest(loginResult.token, {}));
  }, [dispatch, loginResult]);

  const checkLoading = () => {
    if (getLoggedInPartnerDetailsStatus === STATUS.LOADING) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("Name", name),
    CreateItems(
      "Partner",
      {
        1: "Admin (T-bridge Technologies)",
        2: "Bank",
        3: "Mobile Service Providers",
      }[partner_type],
    ),
    CreateItems("Email", email),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Pending", 4: "Rejected" }[status],
    ),
    CreateItems("Region", region),
    CreateItems("District", district),
    CreateItems("Ward", ward),
    CreateItems("Street", street),
    CreateItems("Post Code", post_code),
    CreateItems("Zip Code", zip_code),
    CreateItems("Nearest landmark", nearest),
    CreateItems("Other Details", other),
    CreateItems("Remark", remark),
  ];

  return (
    <Box>
      <PageTitle title={`${name} Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Partner Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
                <tr>
                  {/* <td><b>Map Location</b></td> */}
                  <td>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: "150", borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                      />
                    </AspectRatio>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Sheet>

          {/* Attachments */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Attachments</th>
                  <th></th>
                </tr>
              </thead>
              {attachments.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td>
                      <b>Attachment Name</b>
                    </td>
                    <td>{item.attachment_name}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Attachment Value</b>
                    </td>
                    <td>Tsh. {item.attachment_value}</td>
                  </tr>
                  <tr>
                    {/* <td>
                                    <Typography><b>Attachment File</b></Typography>

                                </td> */}
                    <td>
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: "150", borderRadius: 4 }}
                      >
                        <img src={item.url} loading="lazy" alt="" />
                      </AspectRatio>
                    </td>
                  </tr>
                  <tr style={{ height: "15px" }}></tr>
                </tbody>
              ))}
            </Table>
          </Sheet>
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ partner, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    getLoggedInPartnerDetailsStatus,
    getLoggedInPartnerDetailsResult,
    getLoggedInPartnerDetailsErrorMessage,
  } = partner;

  return {
    loginResult,

    getLoggedInPartnerDetailsStatus,
    getLoggedInPartnerDetailsResult,
    getLoggedInPartnerDetailsErrorMessage,
  };
};

export default connect(mapStateToProps, {})(InfoPage);
